var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShowPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icShowPin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2402452,15.0023957 L18.4854692,10.762439 C18.6023619,10.6459729 18.6666667,10.4902547 18.6666667,10.3242168 C18.6666667,10.1580867 18.6023619,10.0024607 18.4854692,9.8858103 L18.1134793,9.51448238 C17.9967712,9.3976477 17.8407605,9.33333333 17.6745091,9.33333333 C17.5082576,9.33333333 17.3524315,9.3976477 17.2356311,9.51448238 L12.1810154,14.5625149 C12.0637537,14.6795339 11.9995412,14.835897 12,15.0021192 C11.9995412,15.1690786 12.0636615,15.3252575 12.1810154,15.4423686 L17.2309259,20.4855176 C17.3477263,20.6023523 17.5035524,20.6666667 17.6698961,20.6666667 C17.8361476,20.6666667 17.9919737,20.6023523 18.1088663,20.4855176 L18.480764,20.1141897 C18.7227604,19.8725041 18.7227604,19.4790623 18.480764,19.2374688 L14.2402452,15.0023957 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox-for-tester",
    transform: "translate(-196.000000, -473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/arrow-left",
    transform: "translate(202.000000, 477.000000) scale(1, -1) rotate(90.000000) translate(-202.000000, -477.000000) translate(187.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-2)",
    fill: "#646464",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 30 0 30 30 0 30"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShowPin);
export default __webpack_public_path__ + "static/media/icShowPin.be3f3362bb4442172574c214d4100aa4.svg";
export { ForwardRef as ReactComponent };